import { render, staticRenderFns } from "./BasicPieChart.vue?vue&type=template&id=2fb88577&"
import script from "./BasicPieChart.vue?vue&type=script&lang=js&"
export * from "./BasicPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports